import logo from './logo.svg';
import './App.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { RouterProvider } from 'react-router-dom';

import { router } from './routes';

const theme = createTheme({
  palette: {
    coopinfa: {
      main: "#17970A",
      light: '#6fbd61',
      dark: '#6fbd61',
      contrastText: '#FFFFFF',
    },
  },
});

function App() {


  return (
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>

  );
}

export default App;
